import styled from 'styled-components';
import { Link as LinkR } from 'react-router-dom';

export const InfoContainer = styled.div`
  justify-content: center;
  color: #fff;
  min-height: 600px;
  background: linear-gradient(
    112deg,
   #000000a6   -30%,
    #000 130%
  );
`;

export const CardContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;

  @media screen and (max-width: 400px) {

    flex-direction: column;
  }
`

export const InfoWrapper = styled.div`
  z-index: 1;
  height: 860px;
  width: 100%;
  max-width: 100%;
  margin-right: auto;
  margin-left: auto;
  justify-content: center;
`;

export const InfoRow = styled.div`
  display: flex;
  flex-direction: column;

  @media screen and (max-width: 400px) {
      align-items: center;
  }
`;

export const Column1 = styled.div`
  margin-bottom: 15px;
  padding: 0 15px;
  grid-area: col1;
`;

export const Column2 = styled.div`
  margin-bottom: 15px;
  padding: 0 15px;
  grid-area: col2;
`;

export const TextWrapper = styled.div`
  max-width: 540px;
  padding-top: 0;
  padding-bottom: 60px;
`;

export const TopLine = styled.div`
  color: grey;
  font-size: 16px;
  line-height: 16px;
  font-weight: 700;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  margin-bottom: 16px;
`;

export const Heading = styled.h1`
  padding: 24px;
  font-size: 32px;
  font-weight: 520;
  color: ${({ lightText }) => (lightText ? '#f7f8fa' : '#C2B280')};
  justify-content: center;
  align-self: center;
  text-align: center;
  @media screen and (max-width: 480px) {
    font-size: 32px;
  }
`;

export const Subtitle = styled.p`
  max-width: 440px;
  margin-bottom: 35px;
  font-size: 18px;
  line-height: 24px;
  color: ${({ darkText }) => (darkText ? '#010606' : '#fff')};
`;

export const BtnWrap = styled.div`
  display: flex;
  justify-content: flex-start;
`;

export const ImgWrap = styled.div`
  max-width: 555px;
  height: 100%;
`;

export const Img = styled.img`
  width: 100%;
  margin-top: 0;
  margin-right: 0;
  margin-left: 10px;
  padding-right: 0;
`;


export const BtnLink = styled(LinkR)`
  border-radius: 50px;
  background: grey;
  white-space: nowrap;
  padding: 10px 22px;
  color: #C2B280;
  font-size: 16px;
  outline: none;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-decoration: none;

  &:hover {
    transition: all 0.2s ease-in-out;
    background: #fff;
    color: #C2B280;
  }
`;

export const BookRow = styled.div`
  display: flex;
  background: linear-gradient(
    112deg,
   #C2B280 30%,
    white 130%
  );
  flex-direction: column;
  margin: 20px;
  padding: 20px;
  grid-gap: 20px;
  justify-content: center;
  margin-right: 14px;
  margin-left: 14px;
  align-items: center;
  max-width:500px;
  border: 3px solid #white;
  
  @media screen and (min-width: 490px){
    justify-content: space-around;
    padding: 20px;
  }
`;


export const BookThumbnail = styled.video`
 width: 200px;
//  -o-object-fit: cover;
//  object-fit: cover;
//  background: #232a34;
 justify-content: center;
 @media screen and (max-width: 490px){
    justify-content: space-around;
    width: 150px;
    height: 150px;
  }
`;

export const BookThumbnailImage = styled.img`
 width: 200px;
//  -o-object-fit: cover;
//  object-fit: cover;
//  background: #232a34;
 justify-content: center;

   @media screen and (max-width: 490px){
    justify-content: space-around;
    width: 150px;
    height: 150px;
  }
`;


export const BookDescription = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  text-align: center;
  min-width: 60%;
  max-width: 65%;
  @media screen and (min-width: 490px){
    max-width: 30%;
  }
`;

export const BookTitle = styled.div`
  color: white;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  margin-top: 0px;
  margin-bottom: 6px;
  
`;

export const BookDetails = styled.p`
  width: 90%;
  font-size: 12px;
  line-height: 12px;
  color: black;
  margin-bottom: 6px;
`;


export const LibraryButton = styled(LinkR)`
  border-radius: 50px;
  background: #c2b280;
  white-space: nowrap;
  padding: 2px 8px;
  color: #ffffff;
  font-size: 16px;
  outline: none;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-decoration: none;
  text-align: center;
  margin-top:2px;
  min-width: 100px;

  &:hover {
    transition: all 0.2s ease-in-out;
    background: #fff;
    color: #c2b280;
  }

   @media screen and (min-width: 490px){
    min-width: 200px;
  }
`;
